module.exports = __webpack_public_path__ + "-/media/Project/Hyland/Common/images/solution-builder/img/idc-whitepaper-2019-thumbnail.png";